var MDB = window.MDB || {};
MDB.Mangl = MDB.Mangl || {};
MDB.Mangl.Analysis = MDB.Mangl.Analysis || {};

(function ($) {
    $.extend(MDB.Mangl.Analysis, {
    	boot: function(){
    		var analysisForm = $('#analysis-form')
                , isReadOnly = analysisForm.attr('readonly') !== undefined
                , headerBox = $('#analysis-header-box')
                , reportButton = $('.btn-report')
                , nextAnalysisButton = $('.btn-next-analysis');

            MDB.Mangl.Analysis.CompletedStatus = 'Completed';

            //Bypass all reported checks if the user lacks sufficient rights
            MDB.Mangl.Analysis.IsReported = !reportButton.length || analysisForm.find('input[name="IsReported"]').val() === 'True';
            MDB.Mangl.Analysis.AnalysisId = $('#analysis-id').val();

            MDB.Mangl.Analysis.initializeCategorySwitches(analysisForm, isReadOnly);
            MDB.Mangl.Analysis.initializeStarScore(analysisForm, isReadOnly);
            MDB.Mangl.Analysis.initializeImprovementPointDropdown(analysisForm, isReadOnly);
            MDB.Mangl.Analysis.initializeFormHandlers(analysisForm, reportButton.data('required') === 'True');
            MDB.Mangl.Analysis.initializeAudioPlayer(isReadOnly);

            reportButton.on('click', function(e){
                e.preventDefault();

                MDB.Mangl.Analysis.displayReportForm();
            });

            nextAnalysisButton.on('click', function(e){
                e.preventDefault();

                var me = this;

                MDB.Mangl.Analysis.requireReport(function(){
                    window.location.href = me.href;
                });
            });

	        analysisForm.on('submit', function (e, canSubmit) {
        		if (!canSubmit){
            		e.preventDefault();
                    return;
                }
    		});

            analysisForm.find('[name$="DoesNotApply"]').on('click', function (e) {
                if (isReadOnly) {
                    e.preventDefault();
                    return;
                }

        		MDB.Mangl.Analysis.toggleDoesNotApply(this);
            });

            headerBox.find('.k-checkbox').on('click', function (e) {
                if (isReadOnly) {
                    e.preventDefault();
                    return;
                }

                analysisForm.find('[name$="' + this.name + '"]').val(this.checked);
            });

    		analysisForm.find('.analysis-question-container').each(function () {
        		MDB.Mangl.Analysis.toggleDoesNotApply(this);
    		});

    		//Errors should not occur in readonly mode since no data is to be edited
            if (!isReadOnly) {
                MDB.Mangl.Analysis.focusFirstError(analysisForm);
            }else{
                analysisForm.find('[name$="DoesNotApply"], [for$="DoesNotApply"]').attr('readonly', 'readonly');
            }
    	},
    	focusFirstError: function(el){
    		el = $(el);

		    var error = el.find('.field-validation-error:first');
		    if (error.length) {
		        var row = error.closest('.analysis-question-container');
		        MDB.focusElement(row);
		    }
    	},
    	initializeCategorySwitches: function(el, isReadOnly){
    		el = $(el);

	        el.find('input.bootstrap-switch-pill[type="checkbox"]')
	           .hide()
        	   .bootstrapSwitchPill({
		        onSwitchChange: function (evt, state) {
		              var $this = $(this)
		                  , state = state !== undefined ? state :  $this.val()
		                  , categoryContainer = $this.closest('.box-analysis-category-container')
		                  , categoryRow = categoryContainer.find('.box-body .row');
  
  	                   var fun = state ? 'slideDown' : 'slideUp';
	                   categoryRow[fun]();

  		               categoryContainer.find('[name$="IsExpanded"]').val(state);
  		            }
    		    })
	            .filter(':not(.expanded)')
		        .bootstrapSwitch('toggleState');
        },
        initializeStarScore: function(el, isReadOnly){
            el = $(el);
            var inputElements = el.find('input.stars[type="number"]')				
                .prop('readonly', isReadOnly)
                .stars({
                    displayRating: true
                });
				
            el.find('input.norm-star[type="number"]').each(function() {
				
                var normScore = this.value; 
                if(!normScore || normScore == 0) {
                    normScore = 'nvt';
                }
				
                var starContainer = $(this).parents('.analysis-question-container').find('.stars-container');
                // Example of circle fa-circle
				
                var html = '<span class="fa-stack star-norm"><i class="fa fa-circle fa-stack-2x"></i><span class="fa-stack-1x norm-value"></span></span>';
                $(html).find('.norm-value').text(''+normScore).end().appendTo(starContainer);				
				
            });
        },
    	initializeImprovementPointDropdown: function(el, isReadOnly){
            el = $(el);

		    var dropdowns = el.find('[name$="ImprovementPointsSelect"]').kendoMultiSelect({
		        placeholder: MDB.loadResourceString('AnalysisQuestionAnswerModel_ImprovementPointId_Placeholder'),
		        filter: 'contains',
		        change: reScaleKendoMultiSelect,
		        dataBound: function () {
		            var me = this;
		            reScaleKendoMultiSelect.apply(me, arguments);

                    if(isReadOnly){
                        setTimeout(function(){
                            me.readonly(true);
                        }, 0);
                    }
		        }
		    });

            function reScaleKendoMultiSelect(evt) {
                //In the current context, kendo's wrapper does not scale with the content
    		    //So we set the height manually based on the fact if it has content or not
    		    $(this.wrapper).css({
                    'height': ((this.dataItems().length > 1) ? '100%' : '')
    		    });
    		}
    	},
        initializeFormHandlers: function(el, requireReport){
            el = $(el);

            $('button.form-handler').on('click', function () {
                var $this = $(this)
                    , extraInputItems = ['Step', 'Status'];
        
                extraInputItems.forEach(function (item) {
                    var val = $this.data('form-data-' + item);
                    if (val) {
                        var existing = el.find(sprintf('input[name="%s"]', item));
    
                        if (existing.length) {
                            existing.val(val);
                        } else {
                            el.append($(sprintf('<input type="hidden" value="%s" name="%s" />', val, item)));
                        }
                    }
                });

                var status = $this.data('form-data-Status');
                var submitForm = function () {
                    el.trigger('submit', true);  
                };
                
                
                if(status == MDB.Mangl.Analysis.CompletedStatus) {
                    //MDB.Mangl.Analysis.promptUnansweredOptionalQuestions(el, function () {
                    if (requireReport){
                        MDB.Mangl.Analysis.requireReport(submitForm);
                        return;
                    }
					
                    //submitForm();
                    //});

                    //return;
                }

                submitForm();
            });
        },
        promptUnansweredOptionalQuestions: function (el, onConfirm) {
            el = $(el);
            
            var skippedQuestions = _.filter(el.find('.analysis-question-container').has('input[name$="IsOptional"][value="True"]'), function (container) {
                container = $(container);
                
                var doesNotApply = container.find('input[name$="DoesNotApply"]').val() === 'true'
                    , hasScore = !!container.find('input[name$="Score"]').val();
                
                return !doesNotApply && !hasScore;
            });
            
            var skippedQuestionCount = skippedQuestions.length;
            
            if (!skippedQuestionCount){
                onConfirm();
                return;
            }
            
            var promptTitleResource = skippedQuestionCount > 1 ?
                    'Analysis_AnalyseCall_OptionalQuestionsUnanswered_Multiple_Header' : 
                    'Analysis_AnalyseCall_OptionalQuestionsUnanswered_Single_Header'
                , promptTitle = sprintf(MDB.loadResourceString(promptTitleResource), skippedQuestionCount)
                , promptBody = MDB.loadResourceString('Analysis_AnalyseCall_OptionalQuestionsUnanswered_Body');
            
            MDB.prompt(promptTitle, promptBody, function (isOk) {
                if (isOk){
                    onConfirm();
                }
            });
        },
        requireReport: function(callback){
            //Already reported, no need to force a report again
            if(MDB.Mangl.Analysis.IsReported){
                callback();
                return;
            }

            MDB.Mangl.Analysis.displayReportForm({
                successCallback: callback,
                displaySuccessMessage: false
            });
        },
        displayReportForm: function(opts) {
            var fun = this;
            opts = opts || {};

            opts = $.extend({
                successCallback: $.noop,
                errorCallback: $.noop,
                displaySuccessMessage: true
            }, opts);

            //Prevent showing multiple modals when the button is being mashed
            if(fun.modalDisplayed) {
                return;
            }
            fun.modalDisplayed = true;

            $.ajax({
                url: '/MANGL/Analysis/ReportAnalysis?analysisId=' + MDB.Mangl.Analysis.AnalysisId,
                success: function(data){
                    var $data = $(data);

                    //IE does not support the fade animation
                    if (window.ActiveXObject || "ActiveXObject" in window) {
                        $('.modal').removeClass('fade');
                    }

                    $data.modal();

                    $data.on('hidden.bs.modal', function(e){
                        //Modal closed, allow another modal to spawn
                        fun.modalDisplayed = false;
                    })

                    $data.find('.btn-submit').on('click', function(e){
                        var form = $data.find('form');

                        $.ajax({
                            url: form.attr('action'),
                            method: form.attr('method').toUpperCase(),
                            data: form.serialize(),
                            success: function(){
                                MDB.Mangl.Analysis.IsReported = true;

                                if(opts.displaySuccessMessage){
                                    MDB.alert(MDB.loadResourceString('Analysis_AnalyseCall_AnalysisReportedSuccess_Message'));
                                }

                                opts.successCallback();
                            },
                            error: function(err){
                                opts.errorCallback();

                                MDB.alert(MDB.loadResourceString('Analysis_ReportAnalysis_SubmitFailed_Error'), undefined, {
                                    'hidden.bs.modal': function(){
                                        MDB.Mangl.Analysis.displayReportForm(opts);
                                    }
                                });
                            }
                        });
                    });

                    $('body').append($data);
                },
                error: function(err){
                    fun.modalDisplayed = false;
                    MDB.alert(MDB.loadResourceString('Analysis_ReportAnalysis_LoadingFailed_Error'));
                }
            })
        },
        toggleDoesNotApply: function(el){
            el = $(el);

            var questionContainer = el.hasClass('.analysis-question-container') ? el : el.closest('.analysis-question-container')
                , checkbox = questionContainer.find('[name$="DoesNotApply"]')
                , stars = questionContainer.find('.star')
                , score = questionContainer.find('[name$="Score"]')
                , improvementPoint = questionContainer.find('[name$="ImprovementPointsSelect"]')
                , improvementPointDropdown = improvementPoint.data('kendoMultiSelect');

            var checked = checkbox.prop('checked');
            checkbox.val(checked);
    
            if (checked) {
                //Disable dropdown
                improvementPointDropdown.enable(false);
                improvementPointDropdown.value('');

                //Disable score
                stars.removeClass('selected permanent-selected').addClass('disabled');
                questionContainer.find('[name$="Score"]').val(0);
                score.val(undefined);
                score.prop('disabled', true);
                improvementPoint.prop('disabled', true);
            } else {
                //Re-enable dropdown
                improvementPointDropdown.enable(true);
                improvementPoint.prop('disabled', false);

                //Re-enable score
                stars.removeClass('disabled');
                score.prop('disabled', false);
            }
        }
    });
})(jQuery);